export const STORAGE_RATINGS = 'RATINGS';
export const STORAGE_TRACK_RATINGS = 'TRACK_RATINGS';
